import React from "react";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";

class PlannedTournamentEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      staticData: props.staticData,
      plannedTournament: { ...props.plannedTournament },
      handleSubmit: props.handleSubmit,
      handleCancel: props.handleCancel,
    };
  }

  handleChange = (e) => {
    const { plannedTournament } = this.state;
    plannedTournament[e.target.id] = e.target.value;
    this.setState({ plannedTournament });
  };

  render() {
    const {
      plannedTournament: { name, date, startTime, endTime, eventInfoId, scoringFormatId, eventVisibilityId, courtInfo },
      handleSubmit,
      handleCancel,
    } = this.state;

    const { staticData } = this.props;

    return (
      <React.Fragment>
        <Container>
          <Row>
            <Col>
              <Form>
                <Form.Group>
                  <Form.Label className="fw-bold">Name</Form.Label>
                  <Form.Control type="text" placeholder="Tournament name" id="name" value={name} onChange={this.handleChange} />
                </Form.Group>
                <Form.Group className="mt-3">
                  <Form.Label className="fw-bold">Date</Form.Label>
                  <Form.Control type="date" placeholder="Tournament date" id="date" value={date} onChange={this.handleChange} />
                </Form.Group>
                <Form.Group className="mt-3">
                  <Form.Label className="fw-bold">Start Time</Form.Label>
                  <Form.Select id="startTime" onChange={this.handleChange} value={startTime}>
                    <option key="empty" value="">
                      Select start time
                    </option>
                    {Object.keys(staticData.times).map((d) => (
                      <option key={d} value={d}>
                        {staticData.times[d]}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mt-3">
                  <Form.Label className="fw-bold">End Time</Form.Label>
                  <Form.Select id="endTime" onChange={this.handleChange} value={endTime}>
                    <option key="empty" value="">
                      Select end time
                    </option>
                    {Object.keys(staticData.times).map((d) => (
                      <option key={d} value={d}>
                        {staticData.times[d]}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mt-3">
                  <Form.Label className="fw-bold">Event Type</Form.Label>
                  <Form.Select id="eventInfoId" onChange={this.handleChange} value={eventInfoId}>
                    <option key="empty" value="">
                      Select Event Type
                    </option>
                    {Object.keys(staticData.eventInfos).map((d) => (
                      <option key={d} value={d}>
                        {staticData.eventInfos[d]}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mt-3">
                  <Form.Label className="fw-bold">Scoring Format</Form.Label>
                  <Form.Select id="scoringFormatId" onChange={this.handleChange} value={scoringFormatId}>
                    <option key="empty" value="">
                      Select Scoring Format
                    </option>
                    {Object.keys(staticData.scoringFormats).map((d) => (
                      <option key={d} value={d}>
                        {staticData.scoringFormats[d]}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mt-3">
                  <Form.Label className="fw-bold">Visibility</Form.Label>
                  <Form.Select id="eventVisibilityId" onChange={this.handleChange} value={eventVisibilityId}>
                    <option key="empty" value="">
                      Select Visibility
                    </option>
                    {Object.keys(staticData.eventVisibilities).map((d) => (
                      <option key={d} value={d}>
                        {staticData.eventVisibilities[d]}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Text muted>
                    Public - link to tournament registration page will be shared on portal's main page. Private - you will need to manually share the link to
                    the tournament registration page.
                  </Form.Text>
                </Form.Group>
                <Form.Group className="mt-3">
                  <Form.Label className="fw-bold">Court</Form.Label>
                  <Form.Control type="text" placeholder="Courts" id="courtInfo" value={courtInfo} onChange={this.handleChange} />
                  <Form.Text muted>Comma-separated list of courts for the tournament</Form.Text>
                </Form.Group>
                <ButtonGroup className="mt-5">
                  <Button
                    variant="primary"
                    onClick={() => handleSubmit(this.state.plannedTournament)}
                    disabled={!name || !date || !startTime || !endTime || !eventInfoId || !scoringFormatId || !eventVisibilityId}
                  >
                    SAVE
                  </Button>
                  <Button variant="danger" onClick={handleCancel}>
                    CANCEL
                  </Button>
                </ButtonGroup>
              </Form>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default PlannedTournamentEdit;
